module.exports = new __parcel__URL__("gears.ffa28e68.svg").toString();